"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _numberField = _interopRequireDefault(require("./number-field"));

var IntegerField =
/*#__PURE__*/
function (_NumberField) {
  (0, _inherits2.default)(IntegerField, _NumberField);

  function IntegerField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, IntegerField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(IntegerField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'IntegerField');
    return _this;
  }

  (0, _createClass2.default)(IntegerField, [{
    key: "validate",
    value: function validate() {
      (0, _get2.default)((0, _getPrototypeOf3.default)(IntegerField.prototype), "validate", this).call(this);

      this._validateWithRegExp(/^([+-]?[1-9]\d*|0)$/, 'not an integer');
    }
  }]);
  return IntegerField;
}(_numberField.default);

exports.default = IntegerField;